
/*
 *   File :  update-investment.js
 *   Author URI : https://evoqins.com
 *   Description : Show this modal when the customer makes an additional investment in "Goal".
 *   Integrations : null
 *   Version : v1.1
 */

// import Packages
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

// Components
import { CustomTextInput, EditableSlider } from "../FormElements";
import { PrimaryButton, SecondaryButton } from "../Buttons";

// Services
import APIService from "../../Services/api-service";

// Styles
import style from "../../Styles/Components/update-investment.module.scss"

const UpdateInvestmentModal = (props) => {

    const [purpose, setPurpose] = useState("");
    const [purposeError, setPurposeError] = useState("");
    const [expectedCorpus, setExpectedCorpus] = useState(props.data.meta_data.expected_corpus !== null ? props.data.meta_data.expected_corpus.default : 100000);
    const [tenure, setTenure] = useState(props.data.meta_data.tenure !== null ? props.data.meta_data.tenure.default : 10);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("update-investment");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.closeModal();
            setPurpose("");
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.data.meta_data.purpose) {
            setPurpose(props.data.meta_data.purpose);
            setPurposeError("");
        }
        // eslint-disable-next-line
    }, []);

    const _handlePurpose = (value) => {
        setPurpose(value);
        setPurposeError("");
    }

    const _handleSlider = (value, type) => {
        switch (type) {
            case 1:
                setExpectedCorpus(value);
                break;
            case 2:
                setTenure(value);
                break;

            default:
                break;
        }
    }

    const _validate = () => {
        let valid = true;
        if (purpose.length === 0) {
            setPurposeError("Enter investment purpose");
            valid = false;
        }
        if (valid === true) {
            _saveInvestMoreQuestion();
        }
    }
    // API - save invest more question
    const _saveInvestMoreQuestion = () => {
        const url = "/goal/save-invest-more-questions";

        const request = {
            "goal_id": props.data.goal_id,
            "purpose": purpose,
            "expected_corpus": expectedCorpus,
            "tenure": tenure
        }

        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                document.getElementById("close-modal").dispatchEvent(new Event("click"));

                props.success(props.data);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error'
                });
            }
            setButtonLoader(false);
        });
    }


    return (
        <div className={`modal fade ${style.e_update_investment}`}
            id="update-investment"
            tabIndex="-1"
            aria-labelledby="update-investment"
            aria-hidden="true"
            data-bs-keyboard="false" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content pb-4 ${style.e_content} `}>
                    <span id="close-modal"
                        className="d-none"
                        data-bs-dismiss="modal" ></span>
                    <div className="border-bottom-1px border-ash-gray p-3">
                        <p className="e-montserrat-semi-bold e-font-16 e-line-height-24 mb-0 color-eerie-black">Invest more</p>
                    </div>
                    <div className="p-3 pb-0">
                        <p className="e-montserrat-medium e-font-14 e-line-height-22 eerie-black">Before make additional invest you must answer these quick question's</p>
                        <CustomTextInput label="1. What is the purpose of investment? "
                            postfix="*"
                            value={purpose}
                            error={purposeError}
                            placeholder="Enter purpose of investment"
                            handleChange={_handlePurpose} />
                        <EditableSlider label="2. What is your expected corpus?"
                            className="mt-4 pt-2"
                            edit={true}
                            inputPrefix="₹"
                            fontSize="e-font-14"
                            value={expectedCorpus}
                            min={props.data.meta_data.expected_corpus !== null ? props.data.meta_data.expected_corpus.min : 100000}
                            max={props.data.meta_data.expected_corpus !== null ? props.data.meta_data.expected_corpus.max : 1000000000}
                            step={props.data.meta_data.expected_corpus !== null ? props.data.meta_data.expected_corpus.step : 1000}
                            handleChange={(value) => _handleSlider(value, 1)} />
                        <EditableSlider label="3. Tenure"
                            className="mt-4"
                            edit={true}
                            value={tenure}
                            min={props.data.meta_data.tenure !== null ? props.data.meta_data.tenure.min : 1}
                            max={props.data.meta_data.tenure !== null ? props.data.meta_data.tenure.max : 20}
                            step={props.data.meta_data.tenure !== null ? props.data.meta_data.tenure.step : 1}
                            suffix={tenure === 1 ? "Yr" : "Yrs"}
                            singularSuffix={props.data.meta_data.tenure !== null ? props.data.meta_data.tenure.min === 1 ? "Yr" : "Yrs" : "Yr"}
                            pluralSuffix="Yrs"
                            handleChange={(value) => _handleSlider(value, 2)} />

                        <div className="row margin-32px-top">
                            <div className="col-6">
                                <SecondaryButton label="Cancel"
                                    cancel="modal"
                                    className="padding-10px-tb w-100 e-bg-lavender-frost" />
                            </div>
                            <div className="col-6">
                                <PrimaryButton label="Continue"
                                    className="padding-10px-tb  w-100"
                                    disabled={buttonLoader}
                                    showLoader={buttonLoader}
                                    onPress={_validate} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateInvestmentModal